import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { NgbDateParserFormatter, NgbDatepickerI18n, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { RangeDatePicker } from 'app/model/rangeDatePicker';
import { CustomDateParserFormatter } from 'app/shared/configs/custom-date-parse-formatter';
import { I18nSpanish } from 'app/shared/configs/i18n-spanish';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-range-date-picker',
  templateUrl: './range-date-picker.component.html',
  styleUrls: ['./range-date-picker.component.scss'],
  providers: [
    { provide: NgbDatepickerI18n, useClass: I18nSpanish },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter }
  ]
})
export class RangeDatePickerComponent implements OnInit, OnChanges {
  private changeSubject = new Subject<void>()

  public fromDate: NgbDateStruct
  public toDate: NgbDateStruct

  @Input() public title: string
  @Input() public minDate: NgbDateStruct
  @Input() public maxDate: NgbDateStruct

  @Output() public changeEmitter: EventEmitter<RangeDatePicker>

  /**
  * Constructor
  *
  * @param {CustomDateParserFormatter} parser
  * 
  */
  constructor(
    private parser: NgbDateParserFormatter
  ) {
    this.changeEmitter = new EventEmitter<RangeDatePicker>()

    this.changeSubject.pipe(
      debounceTime(300)
    ).subscribe(() => {
      this.emitChanges()
    })
  }

  ngOnInit(): void {
    this.removeRange()
  }

  ngOnChanges(changes: SimpleChanges): void {
    const parser = this.parser as CustomDateParserFormatter

    parser.minDate = this.minDate
    parser.maxDate = this.maxDate
  }

  private createRange(): RangeDatePicker {
    const rangeDatePicker = new RangeDatePicker()
    rangeDatePicker.fromDate = this.fromDate
    rangeDatePicker.toDate = this.toDate

    return rangeDatePicker
  }

  private emitChanges(): void {
    this.changeEmitter.emit(this.createRange())
  }

  public onChange(): void {
    this.changeSubject.next()
  }

  public isDisabled(date: NgbDateStruct, current: { month: number }): boolean {
    return date.month !== current.month
  }

  public clearInput(date: 'fromDate' | 'toDate'): void {
    date === 'fromDate'
      ? this.fromDate = null
      : this.toDate = null

    this.emitChanges()
  }

  public setRange({ fromDate, toDate }: RangeDatePicker): void {
    this.fromDate = fromDate
    this.toDate = toDate
  }

  public removeRange(): void {
    this.fromDate = null
    this.toDate = null
  }
}
